import { useEffect, useState } from "react";

const DEBOUNCE_MILLISECONDS = 300;

export const useDebounce = <T>(value: T): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, DEBOUNCE_MILLISECONDS);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return debouncedValue;
};
